export const leftNavigationCopy = {
  email: '',
  contacts: '',
  settings: '',
  spanishAria: '',
  spanish: '',
  getSupport: '',
  accountSupportBurger: '',
};
